import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { toApiCategoryPath } from 'app/core/utils/category-path.util';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  constructor(
    private _api: ApiService
  ) { }

  // KB-Settings
  getKbArticlesCategory(data): Observable<any> {
    return this._api.postData('cat-article', data)
  }

  postKbArticles(data): Observable<any> {
    return this._api.postData('widget-articles', data);
  }

  getSingleCat(data: {
    kb_slug: string;
    kb_lang: string;
    cat_id?: string | number;
    category_path?: string[];
    category_lookup?: any[];
  }): Observable<any> {
    const { category_lookup, ...requestData } = data;
    const payload = {
      ...requestData,
      ...(requestData.category_path?.length
        ? {
          category_path: toApiCategoryPath(
            requestData.category_path,
            category_lookup,
          ),
        }
        : {}),
    };

    return this._api.postData('single-cat', payload);
  }

  getSingleArticle(data: any): Observable<any> {
    const { category_lookup, ...requestData } = data;
    const payload = {
      ...requestData,
      ...(requestData.category_path?.length
        ? {
          category_path: toApiCategoryPath(
            requestData.category_path,
            category_lookup,
          ),
        }
        : {}),
    };

    return this._api.postData('get-single-article', payload);
  }
}
